<template>
  <!-- -->
  <div class="product-category" :style="{'--active-color': settingData.activeColor, '--background-color': data.componentBackground}">
    <div class="product-search-show">
      <div class="search-input">
        <yq-icon name="iconfont_search" class="input-icon"/>
        <div class="input-key">请输入商品名称</div>
      </div>
    </div>
    <div class="category-area">
      <div class="left">
        <div v-for="i in 10" :class="i === 1? 'active': ''" class="product-category-name">分类{{i+1}}</div>
      </div>
      <div class="right">
        <div class="product-item" v-for="i in 10">
          <alone-image class="title-image"/>
          <div class="product-info">
            <div>商品名称{{i+1}}</div>
            <div>商品价格</div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>


import {watch} from "vue";
import AloneImage from "@/views/h5/common/sys/miniProgram/setting/component/AloneImage.vue";

export default {
  props: {
    data: {
      default: () => {
        return {}
      }
    },
  },
  name: "",
  components: {
    AloneImage
  },
  data() {
    return {
      settingData: {},
      category: [],
      productList: []
    };
  },
  created() {
    this.init();
    watch(() => this.data, () => this.init())
  },
  methods: {
    init() {
      if (!this.data.componentData) {
        this.settingData = {activeColor: "#409eff"};
      } else {
        this.settingData = this.data.componentData;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.product-category{
  display: flex;
  flex-direction: column;
  background-color: transparent !important;
  flex: 1;
  height: 100%;
  overflow: hidden;
  .category-area{
    flex: 1;
    display: flex;
    justify-content: space-between;
    height: 200px;
    overflow: hidden;
  }

  .left{
    width: 22%;
    box-sizing: border-box;
    background-color: var(--background-color);
    overflow: auto;
    .product-category-name{
      white-space: nowrap;
      overflow: hidden;
      line-height: 100px;
      padding: 0 10px;
      border-bottom: 10px solid transparent;
      &.active{
        color: var(--active-color);
        border-bottom: 10px solid var(--active-color);
      }
    }
  }
  .right{
    width: 76%;
    height: 100%;
    overflow: auto;
    .product-item{
      background-color: var(--background-color);
      display: flex;
      border-radius: 10px;
      margin-bottom: 10px;
      &:last-child{
        margin-bottom: 0;
      }
      .title-image{
        width: 200px;
        margin-right: 30px;
      }
      .product-info{
        flex: 1;
      }
    }
  }
}

.product-search-show{
  padding: 20px;
  border-radius: 10px;
  background-color: var(--background-color);
  .search-input{
    background: var(--yq-background-color);
    position: relative;
    box-sizing: border-box;
    padding-left: 80px;
    .input-icon{
      width: 80px;
      text-align: center;
      line-height: 80px;
      position: absolute;
      left: 30px;
      top: 0;
      font-size: var(--font-size-large);
      color: var(--font-color-desc);
    }
    .input-key{
      height: 80px;
      line-height: 80px;
      font-size: var(--font-size-small);
      color: var(--font-color-desc);
    }
  }
}
</style>